import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Cangbientonghop from "components/Duongthuy/Cangbien/Cangbientonghop.js";
import Phuluchanghoa from "components/Duongthuy/Cangbien/Phuluchanghoa.js";
export default function CangbienTH() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo sản lượng hàng hóa thông qua các cảng",
            tabContent: <Cangbientonghop />,
          },
          {
            tabName: "Báo cáo theo phụ lục",
            tabContent: <Phuluchanghoa />,
          },
        ]}
      />
    </div>
  );
}
